import * as React from "react";
import { Input, Label } from "uxp/components";
import { IUIPropertyDefinition } from '../common';

export function SimpleNumberProperty(title: string, props: number): IUIPropertyDefinition<number> {
    return {
        defaults: props,
        render: (props) => {

            return <div className='wd-prop-item'>
                {/* <div className='wd-prop-item-title'>{}</div> */}
                <div className='wd-prop-item-editor'>
                    <Label>{title}</Label>

                    <Input
                        type="number"
                        value={props.uiProps?.toString() || ''}
                        onChange={s => {
                            let number = Number(s)
                            if (isFinite(number) && !isNaN(number)) {
                                props.onChange(number)
                            }
                            else {
                                props.onChange(0)
                            }
                        }}

                        className="widget-designer-input"
                    />
                </div>
            </div>;
        }
    };
}